import common from '@/api/common'
import { v4 as uuidv4 } from 'uuid'
/**
 * 通用js方法封装处理
 * Copyright (c) 2019 ruoyi
 */

// 日期格式化
export function parseTime(time, pattern) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
      time = parseInt(time)
    } else if (typeof time === 'string') {
      time = time
        .replace(new RegExp(/-/gm), '/')
        .replace('T', ' ')
        .replace(new RegExp(/\.[\d]{3}/gm), '')
    }
    if (typeof time === 'number' && time.toString().length === 10) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

// 判断两个数组是否有相同值
export function hasCommonValue(arr1, arr2) {
  return arr1.some((item) => arr2.includes(item))
}

// 表单重置
export function resetForm(refName) {
  if (this.$refs[refName]) {
    this.$refs[refName].resetFields()
  }
}

// 添加日期范围
export function addDateRange(params, dateRange, propName) {
  let search = params
  search.params = typeof search.params === 'object' && search.params !== null && !Array.isArray(search.params) ? search.params : {}
  dateRange = Array.isArray(dateRange) ? dateRange : []
  if (typeof propName === 'undefined') {
    search.params['beginTime'] = dateRange[0]
    search.params['endTime'] = dateRange[1]
  } else {
    search.params['begin' + propName] = dateRange[0]
    search.params['end' + propName] = dateRange[1]
  }
  return search
}

// 回显数据字典
export function selectDictLabel(datas, value) {
  if (value === undefined) {
    return ''
  }
  let actions = []
  Object.keys(datas).forEach((key) => {
    if (datas[key].value == '' + value) {
      actions.push(datas[key].label)
    }
  })
  if (actions.length === 0) {
    actions.push(value)
  }
  return actions.join('')
}

// 回显数据字典（字符串数组）
export function selectDictLabels(datas, value, separator) {
  if (value === undefined) {
    return ''
  }
  let actions = []
  let currentSeparator = undefined === separator ? ',' : separator
  let temp = value.split(currentSeparator)
  Object.keys(value.split(currentSeparator)).forEach((val) => {
    const match = Object.keys(datas).some((key) => {
      if (datas[key].value == '' + temp[val]) {
        actions.push(datas[key].label + currentSeparator)
        return true
      }
      return false
    })
    if (!match) {
      actions.push(temp[val] + currentSeparator)
    }
  })
  return actions.join('').substring(0, actions.join('').length - 1)
}

// 字符串格式化(%s )
export function sprintf(str) {
  let args = arguments,
    flag = true,
    i = 1
  str = str.replace(/%s/g, function () {
    let arg = args[i++]
    if (typeof arg === 'undefined') {
      flag = false
      return ''
    }
    return arg
  })
  return flag ? str : ''
}

// 转换字符串，undefined,null等转化为""
export function parseStrEmpty(str) {
  if (!str || str == 'undefined' || str == 'null') {
    return ''
  }
  return str
}

// 数据合并
export function mergeRecursive(source, target) {
  for (let p in target) {
    try {
      if (target[p].constructor == Object) {
        source[p] = mergeRecursive(source[p], target[p])
      } else {
        source[p] = target[p]
      }
    } catch (e) {
      source[p] = target[p]
    }
  }
  return source
}

/**
 * 构造树型结构数据
 * @param {*} data 数据源
 * @param {*} id id字段 默认 'id'
 * @param {*} parentId 父节点字段 默认 'parentId'
 * @param {*} children 孩子节点字段 默认 'children'
 */
export function handleTree(data, id, parentId, children) {
  let config = {
    id: id || 'id',
    parentId: parentId || 'parentId',
    childrenList: children || 'children',
  }

  let childrenListMap = {}
  let nodeIds = {}
  let tree = []

  for (let d of data) {
    let parentId = d[config.parentId]
    if (childrenListMap[parentId] == null) {
      childrenListMap[parentId] = []
    }
    nodeIds[d[config.id]] = d
    childrenListMap[parentId].push(d)
  }

  for (let d of data) {
    let parentId = d[config.parentId]
    if (nodeIds[parentId] == null) {
      tree.push(d)
    }
  }

  for (let t of tree) {
    adaptToChildrenList(t)
  }

  function adaptToChildrenList(o) {
    if (childrenListMap[o[config.id]] !== null) {
      o[config.childrenList] = childrenListMap[o[config.id]]
    }
    if (o[config.childrenList]) {
      for (let c of o[config.childrenList]) {
        adaptToChildrenList(c)
      }
    }
  }
  return tree
}

/**
 * 参数处理
 * @param {*} params  参数
 */
export function tansParams(params) {
  let result = ''
  for (const propName of Object.keys(params)) {
    const value = params[propName]
    let part = encodeURIComponent(propName) + '='
    if (value !== null && value !== '' && typeof value !== 'undefined') {
      if (typeof value === 'object') {
        for (const key of Object.keys(value)) {
          if (value[key] !== null && value !== '' && typeof value[key] !== 'undefined') {
            let params = propName + '[' + key + ']'
            let subPart = encodeURIComponent(params) + '='
            result += subPart + encodeURIComponent(value[key]) + '&'
          }
        }
      } else {
        result += part + encodeURIComponent(value) + '&'
      }
    }
  }
  return result
}

// 验证是否为blob格式
export async function blobValidate(data) {
  try {
    const text = await data.text()
    JSON.parse(text)
    return false
  } catch (error) {
    return true
  }
}

export function exportExcel(res, fileName) {
  let blob = new Blob([res], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })
  let url = window.URL.createObjectURL(blob)
  const link = document.createElement('a') // 创建a标签
  document.body.appendChild(link)
  link.href = url
  link.download = (fileName || new Date().getTime()) + '.xlsx' // 重命名文件
  link.click()
  document.body.removeChild(link) //下载完成移除元素
  window.URL.revokeObjectURL(url) //释放掉blob对象
}

// 做一个分片上传
export async function sectionUpload(file, callBack) {
  // 每个文件切片大小定为5MB
  let sliceSize = 0.5 * 1024 * 1024
  //文件大小限制为最大1个G，可根据需求修改
  let filesizes = 1 * 1024 * 1024 * 1024
  let that = this
  const blob = file.file
  const fileSize = blob.size // 文件大小
  const fileName = blob.name // 文件名
  //计算文件切片总数
  const totalSlice = Math.ceil(fileSize / sliceSize)
  if (fileSize <= filesizes) {
    that.showbtn = false
    // 循环上传
    for (let i = 0; i < totalSlice; i++) {
      let start = i * sliceSize
      let chunk = blob.slice(start, Math.min(fileSize, start + sliceSize))
      const formData = new FormData()
      formData.append('file', chunk)
      formData.append('signal', blob.uid)
      formData.append('name', fileName)
      formData.append('size', fileSize)
      formData.append('chunks', totalSlice)
      formData.append('chunk', i + 1)
      let res = await uploadExcleAndZip(2, formData) //一个分片上传完成后再调用接口上传下一片
      console.log(res)
      if (res.errCode == 0) {
        this.progress = ((i + 1) / totalSlice).toFixed(1) * 100 //控制进度条
        setTimeout(function () {
          if (i + 1 == totalSlice) {
            callBack({
              type: 'success',
              message: '上传成功',
            })
          }
        }, 1000)
      } else {
        callBack({
          type: 'error',
          message: '上传失败',
        })
      }
    }
  } else {
    callBack({
      type: 'error',
      message: '文件大小超出1G',
    })
  }
}

function uploadExcleAndZip(type, formData) {}

export function readJson(url) {
  return fetch(url).then((res) => {
    if (!res.ok) {
      throw new Error('Network response was not ok')
    }
    return res.json()
  })
}

export function readText(url) {
  return fetch(url).then((res) => {
    if (!res.ok) {
      throw new Error('Network response was not ok')
    }
    return res.text()
  })
}

// 选择地址
export function addressCascader() {
  return {
    lazy: true,
    lazyLoad(node, resolve) {
      common.getAreaList({ pid: node.level == 0 ? 0 : node.data.areaId }).then((res) => {
        let nodes = res.data.rows.map((row) => ({
          areaId: row.id,
          value: row.name,
          label: row.name,
          leaf: !row.hasChild,
        }))
        // 通过调用resolve将子节点数据返回，通知组件数据加载完成
        resolve(nodes)
      })
    },
  }
}

export function deepCopy(obj) {
  if (typeof obj !== 'object' || obj === null) {
    return obj
  }

  let newObj = Array.isArray(obj) ? [] : {}

  for (let key in obj) {
    newObj[key] = deepCopy(obj[key])
  }

  return newObj
}

export function uuid() {
  return uuidv4()
}
